"use strict";

var _classCallCheck = require("/codebuild/output/src411074015/src/code-for-humans-private/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src411074015/src/code-for-humans-private/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Light = void 0;

var LightArea_1 = require("./LightArea");

var LightShadow_1 = require("./LightShadow");

var Light = /*#__PURE__*/function () {
  function Light() {
    _classCallCheck(this, Light);

    this.area = new LightArea_1.LightArea();
    this.shadow = new LightShadow_1.LightShadow();
  }

  _createClass(Light, [{
    key: "load",
    value: function load(data) {
      if (data === undefined) {
        return;
      }

      this.area.load(data.area);
      this.shadow.load(data.shadow);
    }
  }]);

  return Light;
}();

exports.Light = Light;